module.exports = __webpack_public_path__ + "static/img/book.aeeef1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book.png
// module id = yWC+
// module chunks = 10